import { parseMedia } from '@remotion/media-parser';

// Whether a video the user picked carries an audio track. Projects and
// libraries are transcribed, so a video without one always fails processing
// (backend failure_code `source_no_audio`), e.g. a news block exported from the
// editing software with audio turned off.
export type AudioTrackPresence = 'present' | 'absent' | 'unknown';

// 'absent' needs every track to be video: the parser files an audio codec it
// does not know as 'other', and rejecting a video that has sound is worse than
// letting a silent one fail on the server.
export function audioPresenceFromTracks(
  tracks: ReadonlyArray<{ type: string }>,
): AudioTrackPresence {
  if (tracks.some((track) => track.type === 'audio')) return 'present';
  if (tracks.length > 0 && tracks.every((track) => track.type === 'video')) return 'absent';
  return 'unknown';
}

// Reads only the container header (sliced from the file, nothing is uploaded or
// decoded). Any parse failure is 'unknown' so the upload goes ahead as before.
export async function detectAudioTrack(file: Blob): Promise<AudioTrackPresence> {
  try {
    const { tracks } = await parseMedia({ src: file, fields: { tracks: true } });
    return audioPresenceFromTracks(tracks);
  } catch (error) {
    console.error('Error reading video tracks:', error);
    return 'unknown';
  }
}
